// role types
export const GDPC_ADMIN = 'IFRC Admin'
export const NS_ADMIN = 'NS Admin'
export const NS_EDITOR = 'NS Editor'
export const API_USER = 'API User'

// role types ID
export const GDPC_ADMIN_ID = 3
export const NS_ADMIN_ID = 4
export const NS_EDITOR_ID = 5
export const API_USER_ID = 1

// permission types
export const VIEW_BACKEND = 'view-backend'
export const USERS_VIEW = 'users-view'
export const USERS_LIST = 'users-list'
export const USERS_CREATE = 'users-create'
export const USERS_EDIT = 'users-edit'
export const USERS_DELETE = 'users-delete'
export const USERS_DEACTIVATE = 'users-deactivate'
export const USERS_REACTIVATE = 'users-reactivate'
export const CONTENT_PUBLISH = 'content-publish'
export const CONTENT_CREATE = 'content-create'
export const CONTENT_EDIT = 'content-edit'
export const CONTENT_DELETE = 'content-delete'
export const CONTENT_VIEW = 'content-view'
export const HAZARD_TYPE_CREATE = 'hz-type-create'
export const ALL_ORGANISATIONS = 'organisations_all'
export const TERMS_UPDATE = 'terms-update'
export const API_STATS_VIEW = 'api-stats-view'
